import MuiDivider from '@mui/material/Divider';

interface Props {
  width?: string;
  height?: '0.075rem' | '0.1rem' | '0.125rem' | '0.25rem';
  color?: string;
}

export function Divider({ width = '100%', height = '0.1rem', color = 'grey' }: Props) {
  return (
    <MuiDivider
      sx={{
        width,
        height,
        background: color,
      }}
    />
  );
}
